var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-breadcrumb", { attrs: { name: "Generate Marketing Email" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Create HubSpot Marketing Email Draft",
                    "sub-title":
                      "Fill in the draft details, generate the storefront HTML, and send the complete payload to the GreenLists HubSpot API.",
                    "with-footer": "",
                    "second-body": !!_vm.submissionResult,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: _vm.formState.processing,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submitDraft.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v("\n            Submit\n            "),
                              _vm.formState.processing
                                ? _c("b-spinner", {
                                    staticClass: "ml-1",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "second-body",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-wrap justify-content-between align-items-center mb-3",
                            },
                            [
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Submission Result"),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-muted mb-0" }, [
                                  _vm._v(
                                    "\n                HubSpot response and generated HTML preview from the latest submission.\n              "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-badge", { attrs: { variant: "success" } }, [
                                _vm._v("Draft Created"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3 mb-lg-0",
                                  attrs: { lg: "5" },
                                },
                                [
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "h-100",
                                      attrs: { "bg-variant": "light" },
                                    },
                                    [
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "text-uppercase text-muted mb-3",
                                        },
                                        [_vm._v("HubSpot Response")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "pre",
                                        {
                                          staticClass:
                                            "mb-0 small marketing-email-response",
                                        },
                                        [_vm._v(_vm._s(_vm.formattedResult))]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { lg: "7" } },
                                [
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "h-100",
                                      attrs: { "bg-variant": "light" },
                                    },
                                    [
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "text-uppercase text-muted mb-3",
                                        },
                                        [_vm._v("Generated HTML Preview")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "marketing-email-preview",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.submissionResult.html
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submitDraft.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-for": "marketing-email-name",
                                    "invalid-feedback": _vm.validation.name,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                  Draft Name "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "required-asterisk",
                                            },
                                            [_vm._v("*")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-name",
                                      state: _vm.fieldState("name"),
                                      placeholder:
                                        "Storefronts April 2026 Draft",
                                    },
                                    model: {
                                      value: _vm.form.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "name", $$v)
                                      },
                                      expression: "form.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-for": "marketing-email-subject",
                                    "invalid-feedback": _vm.validation.subject,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                  Subject "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "required-asterisk",
                                            },
                                            [_vm._v("*")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-subject",
                                      state: _vm.fieldState("subject"),
                                      placeholder:
                                        "Explore New Storefronts on GreenLists",
                                    },
                                    model: {
                                      value: _vm.form.subject,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "subject", $$v)
                                      },
                                      expression: "form.subject",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Email Title",
                                    "label-for": "marketing-email-title",
                                    description:
                                      "Used when generating the storefront email HTML.",
                                    "invalid-feedback": _vm.validation.title,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-title",
                                      state: _vm.fieldState("title"),
                                      placeholder: "Shop By Store",
                                    },
                                    model: {
                                      value: _vm.form.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "title", $$v)
                                      },
                                      expression: "form.title",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Preview Text",
                                    "label-for": "marketing-email-preview-text",
                                    "invalid-feedback":
                                      _vm.validation.previewText,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-preview-text",
                                      state: _vm.fieldState("previewText"),
                                      placeholder:
                                        "Browse the latest storefronts on GreenLists",
                                    },
                                    model: {
                                      value: _vm.form.previewText,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "previewText", $$v)
                                      },
                                      expression: "form.previewText",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "From Name",
                                    "label-for": "marketing-email-from-name",
                                    "invalid-feedback": _vm.validation.fromName,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-from-name",
                                      state: _vm.fieldState("fromName"),
                                      placeholder: "GreenLists",
                                    },
                                    model: {
                                      value: _vm.form.fromName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "fromName", $$v)
                                      },
                                      expression: "form.fromName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Reply-To",
                                    "label-for": "marketing-email-reply-to",
                                    "invalid-feedback": _vm.validation.replyTo,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-reply-to",
                                      state: _vm.fieldState("replyTo"),
                                      placeholder: "support@greenlists.com",
                                      type: "email",
                                    },
                                    model: {
                                      value: _vm.form.replyTo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "replyTo", $$v)
                                      },
                                      expression: "form.replyTo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Custom Reply-To",
                                    "label-for":
                                      "marketing-email-custom-reply-to",
                                    "invalid-feedback":
                                      _vm.validation.customReplyTo,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-custom-reply-to",
                                      state: _vm.fieldState("customReplyTo"),
                                      placeholder: "marketing@greenlists.com",
                                      type: "email",
                                    },
                                    model: {
                                      value: _vm.form.customReplyTo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "customReplyTo", $$v)
                                      },
                                      expression: "form.customReplyTo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Language",
                                    "label-for": "marketing-email-language",
                                    "invalid-feedback": _vm.validation.language,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-language",
                                      state: _vm.fieldState("language"),
                                      placeholder: "en",
                                    },
                                    model: {
                                      value: _vm.form.language,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "language", $$v)
                                      },
                                      expression: "form.language",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Active Domain",
                                    "label-for":
                                      "marketing-email-active-domain",
                                    "invalid-feedback":
                                      _vm.validation.activeDomain,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-active-domain",
                                      state: _vm.fieldState("activeDomain"),
                                      placeholder: "info.greenlists.com",
                                    },
                                    model: {
                                      value: _vm.form.activeDomain,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "activeDomain", $$v)
                                      },
                                      expression: "form.activeDomain",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Campaign",
                                    "label-for": "marketing-email-campaign",
                                    "invalid-feedback": _vm.validation.campaign,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-campaign",
                                      state: _vm.fieldState("campaign"),
                                      placeholder: "HubSpot campaign id",
                                    },
                                    model: {
                                      value: _vm.form.campaign,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "campaign", $$v)
                                      },
                                      expression: "form.campaign",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Folder ID",
                                    "label-for": "marketing-email-folder-id",
                                    "invalid-feedback":
                                      _vm.validation.folderIdV2,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-folder-id",
                                      state: _vm.fieldState("folderIdV2"),
                                      type: "number",
                                    },
                                    model: {
                                      value: _vm.form.folderIdV2,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "folderIdV2",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "form.folderIdV2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Business Unit ID",
                                    "label-for":
                                      "marketing-email-business-unit-id",
                                    "invalid-feedback":
                                      _vm.validation.businessUnitId,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-business-unit-id",
                                      state: _vm.fieldState("businessUnitId"),
                                      type: "number",
                                    },
                                    model: {
                                      value: _vm.form.businessUnitId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "businessUnitId",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "form.businessUnitId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Office Location ID",
                                    "label-for":
                                      "marketing-email-office-location-id",
                                    "invalid-feedback":
                                      _vm.validation.officeLocationId,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-office-location-id",
                                      state: _vm.fieldState("officeLocationId"),
                                    },
                                    model: {
                                      value: _vm.form.officeLocationId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "officeLocationId",
                                          $$v
                                        )
                                      },
                                      expression: "form.officeLocationId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Preferences Group ID",
                                    "label-for":
                                      "marketing-email-preferences-group-id",
                                    "invalid-feedback":
                                      _vm.validation.preferencesGroupId,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-preferences-group-id",
                                      state:
                                        _vm.fieldState("preferencesGroupId"),
                                    },
                                    model: {
                                      value: _vm.form.preferencesGroupId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "preferencesGroupId",
                                          $$v
                                        )
                                      },
                                      expression: "form.preferencesGroupId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Subscription ID",
                                    "label-for":
                                      "marketing-email-subscription-id",
                                    "invalid-feedback":
                                      _vm.validation.subscriptionId,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-subscription-id",
                                      state: _vm.fieldState("subscriptionId"),
                                    },
                                    model: {
                                      value: _vm.form.subscriptionId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "subscriptionId",
                                          $$v
                                        )
                                      },
                                      expression: "form.subscriptionId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Subscription Name",
                                    "label-for":
                                      "marketing-email-subscription-name",
                                    "invalid-feedback":
                                      _vm.validation.subscriptionName,
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "marketing-email-subscription-name",
                                      state: _vm.fieldState("subscriptionName"),
                                    },
                                    model: {
                                      value: _vm.form.subscriptionName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "subscriptionName",
                                          $$v
                                        )
                                      },
                                      expression: "form.subscriptionName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Plain Text Version",
                            "label-for": "marketing-email-plain-text",
                            description:
                              "Optional. Leave blank to auto-generate from the storefront HTML.",
                            "invalid-feedback": _vm.validation.plainTextVersion,
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "marketing-email-plain-text",
                              state: _vm.fieldState("plainTextVersion"),
                              rows: "4",
                            },
                            model: {
                              value: _vm.form.plainTextVersion,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "plainTextVersion", $$v)
                              },
                              expression: "form.plainTextVersion",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }